'use client';

import { tmaActions } from '@/bootstrap/tmaActions';
import { useCapability } from '@/runtime/useCapability';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './SessionExpiredScreen.translations';

// WHY: Telegram выдаёт initData один раз на запуск и не обновляет — reload повторит тот же протухший payload, retry
// бессмыслен
export function SessionExpiredScreen() {
  const { t } = useLocalTranslation(translations);
  const canClose = useCapability('closeApp');

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: 'var(--tg-theme-bg-color, #1a1a1a)' }}
    >
      <div className="text-center max-w-xs px-6" style={{ color: 'var(--tg-theme-text-color, #fff)' }}>
        <div className="text-6xl mb-6">⌛</div>
        <h1 className="text-2xl font-semibold m-0">{t('title')}</h1>
        <p className="mt-3 text-sm opacity-70 leading-snug">{t('description')}</p>
        {canClose && (
          <button
            type="button"
            onClick={() => void tmaActions.close()}
            className="mt-6 w-full rounded-xl px-4 py-3 text-sm font-medium bg-white/10 hover:bg-white/15 transition-colors"
          >
            {t('action')}
          </button>
        )}
      </div>
    </div>
  );
}
